var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$fetchState.pending)?_c('skeleton-loader-page-head'):_c('div',[_c('area-page-header',{attrs:{"area":_vm.area}}),_vm._v(" "),_c('v-container',{staticClass:"area-container"},[_c('nuxt-child',{key:_vm.$route.params.areaId,attrs:{"area":_vm.area}})],1),_vm._v(" "),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }